import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import Registration from './pages/registration';
import Login from './pages/login';
import AccountSettings from './pages/account-settings';
import Dashboard from './pages/dashboard';
import ClinicalRecommendation from './pages/clinical-recommendation';
import PurchaseCredits from "./pages/purchase-credits";
import RegionalNetworkDirectory from "./pages/regional-network-directory";
import AuthCallback from './pages/auth-callback';
import ProfileCompletion from './pages/profile-completion';
import PendingApproval from './pages/pending-approval';
import UserGuide from './pages/user-guide';
import ContactSupport from './pages/contact-support';
import GuidelinesReference from './pages/guidelines-reference';
import EmailVerification from './pages/email-verification';
import SearchGuidelines from "pages/search-guidelines";
import MedicalRequisition from './pages/medical-requisition';
import DoctorChat from './pages/doctor-chat';
import TechnologistPortal from './pages/technologist-portal';
import { AuthProvider } from './contexts/AuthContext';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/login" element={<Login />} />
            <Route path="/account-settings" element={<AccountSettings />} />
            <Route path="/clinical-recommendation" element={<ClinicalRecommendation />} />
            <Route path="/medical-requisition" element={<MedicalRequisition />} />
            <Route path="/doctor-chat" element={<DoctorChat />} />
            <Route path="/technologist-portal" element={<TechnologistPortal />} />
            <Route path="/purchase-credits" element={<PurchaseCredits />} />
            <Route path="/regional-network-directory" element={<RegionalNetworkDirectory />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/profile-completion" element={<ProfileCompletion />} />
            <Route path="/pending-approval" element={<PendingApproval />} />
            <Route path="/user-guide" element={<UserGuide />} />
            <Route path="/contact-support" element={<ContactSupport />} />
            <Route path="/guidelines-reference" element={<GuidelinesReference />} />
            <Route path="/search-guidelines" element={<SearchGuidelines />} />
            <Route path="/email-verification" element={<EmailVerification />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;